import React, { useEffect, useState } from "react";
import AlertCard from "components/common/AlertCard";
import Dropdown from "components/common/Dropdown";
import { Link, useParams } from "react-router-dom";
import useGetInventoryIncidents from "hooks/inventoryHooks/useGetInventoryIncidents";
import useGetAllWarehouses from "hooks/useGetAllWarehouses";
import Loader from "components/common/Loader";
import TextInput from "components/common/InputField/TextInput";
import useGetInventoryStockOut from "hooks/inventoryHooks/useGetInventoryStockOut";

const PotentialStockOuts = () => {
    const { productId } = useParams();
    const [showAll, setShowAll] = useState(false);
    const potentialStockOutContent = document.getElementById("potentialStockOutContent");
    const {
        data,
        isFetching,
        pagination,
        isLoadingMore,
        handleIncidentTypeChange,
        incidentType,
        handleWarehouseChange,
    } = useGetInventoryStockOut(productId, potentialStockOutContent);

    const {
        data: warehouseList,
        warehouseValue: warehouseDataValue,
        searchTwo,
        handleDebouncedChangeTwo,
        handleSearchTwo,
        searchResult,
        handleFilterChange: filterChange,
        handleClearFilter: clearFilter,
    } = useGetAllWarehouses();

    const handleShowMore = () => {
        setShowAll(true);
    };

    useEffect(() => {
        handleIncidentTypeChange("stockout");
    }, []);

    const itemsToShow = showAll ? data : data?.slice(0, 2);

    return (
        <div className="max-h-[400px] overflow-y-auto" id="potentialStockOutContent">
            {isFetching && data?.length === 0 && warehouseDataValue?.name === "" ? (
                <Loader />
            ) : (
                <>
                    <div className="flex justify-between items-center mb-4">
                        {/* <h4 className="text-xl font-rocGroteskMedium">Potential stockout</h4> */}
                        <h4 className="text-xl text-[#FF0000] font-rocGroteskMedium">
                            <i className="ri-arrow-down-line mr-1.5"></i>
                            <span>Potential Stockout</span>
                        </h4>
                        <div className="border rounded border-slate-200">
                            <Dropdown
                                handleChange={(name, value) => {
                                    console.log("first", name, value);
                                }}
                                dropdown={
                                    <div className="flex items-center space-x-2  whitespace-nowrap h-[40px] py-2 px-4 justify-between ">
                                        <div className="flex items-center space-x-1">
                                            <i className="ri-map-pin-line text-sm text-g-75 "></i>
                                            <span
                                                className={`text-g-75 font-rocGroteskMedium text-[13px]`}
                                            >
                                                {warehouseDataValue?.name ||
                                                    "All Warehouses / Outlets"}
                                            </span>
                                            {warehouseDataValue?.name && (
                                                <i
                                                    onClick={() => {
                                                        handleWarehouseChange("");
                                                        clearFilter();
                                                    }}
                                                    className="ri-close-circle-line text-slate-500"
                                                ></i>
                                            )}
                                        </div>

                                        <i className="ri-arrow-down-s-line text-g-75"></i>
                                    </div>
                                }
                                search={
                                    <div>
                                        <TextInput
                                            value={searchTwo}
                                            name={"search"}
                                            type={"text"}
                                            required={false}
                                            onChange={handleSearchTwo}
                                            onInput={handleDebouncedChangeTwo}
                                            inputPlaceholder="Search warehouse"
                                            containerClassname=""
                                            // inputContainerClassname={"!border-none !rounded-none "}
                                            // inputClassName="w-[50%]"
                                        />
                                    </div>
                                }
                                dropdownContainerClasses={`shadow-cardShadow-4 !right-0  border border-slate-100  rounded `}
                                dropdownOptions={[
                                    {
                                        customChild: (
                                            <div>
                                                <div>
                                                    {searchResult?.map((warehouse) => {
                                                        return (
                                                            <div
                                                                key={warehouse?._id}
                                                                onClick={() => {
                                                                    filterChange(
                                                                        warehouse?.warehouseName,
                                                                        warehouse?._id
                                                                    );
                                                                    handleWarehouseChange(
                                                                        warehouse?._id
                                                                    );
                                                                }}
                                                            >
                                                                <div
                                                                    className={`flex items-center space-x-3 max-w-[300px] px-3 py-2 hover:bg-slate-100 cursor-pointer ${
                                                                        warehouseDataValue?.value ===
                                                                            warehouse?._id &&
                                                                        "bg-slate-100"
                                                                    }`}
                                                                >
                                                                    <i className="ri-map-pin-line text-base text-g-75 "></i>
                                                                    <div>
                                                                        <span
                                                                            className={`block text-g-75 text-sm font-rocGroteskMedium ${
                                                                                warehouse?.address
                                                                                    ?.address &&
                                                                                "mb-[2px]"
                                                                            }`}
                                                                        >
                                                                            {
                                                                                warehouse?.warehouseName
                                                                            }
                                                                        </span>
                                                                        <span className="block  text-g-75 text-sm font-rocGroteskMedium ">
                                                                            {
                                                                                warehouse?.address
                                                                                    ?.address
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ),
                                    },
                                ]}
                            />
                        </div>
                    </div>

                    {data?.length > 0 ? (
                        <>
                            <div className="space-y-4 shadow-boxShadow-12" id="dashboardContent">
                                {itemsToShow?.map((item: any, idx) => (
                                    <Link
                                        key={idx}
                                        to={`/dashboard/inventory/alert/${item?._id}/${idx}`}
                                    >
                                        <AlertCard
                                            key={idx}
                                            index={idx}
                                            productName={item?.inventory?.productName}
                                            stockOutDescription={
                                                item?.inventory?.productDescription
                                            }
                                            risk={item?.risk}
                                            createdAt={item?.createdAt}
                                            status={item?.status}
                                            stockOutQty={item?.qty || 0}
                                            incidentType={item?.incidentType}
                                            potentialRevenue={
                                                item?.inventory?.unitCost?.amount * item?.qty || 0
                                            }
                                            forcastedStockDuration={item?.forecastLength}
                                            stockOutDate={item?.stockoutDate || "N/A"}
                                            currency={item?.inventory?.currency}
                                            uom={
                                                item?.inventory?.productStockDetails
                                                    ?.unitOfMeasurement || "N/A"
                                            }
                                            isStockout={true}
                                        />
                                    </Link>
                                ))}
                                {!showAll && data?.length > 2 && (
                                    <div
                                        className="space-x-2.5 flex items-center justify-center py-[14px] border border-n-20 cursor-pointer"
                                        onClick={handleShowMore}
                                    >
                                        <span className="text-sm font-rocGroteskMedium mt-[2px]">
                                            Show more
                                        </span>
                                        <i className="ri-arrow-right-line text-lg"></i>
                                    </div>
                                )}
                            </div>
                            {isFetching && isLoadingMore && (
                                <div className="flex justify-center my-4">
                                    <Loader color="gm-25" size={4} />
                                </div>
                            )}
                            {pagination?.currentPage === pagination?.noOfPages && showAll && (
                                <div className="flex my-4 justify-center text-slate-500 text-sm font-rocGroteskMedium">
                                    End of list
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="items-center flex  h-[30%]  justify-center my-[20%]">
                            <div className="space-y-2  text-center">
                                <i className="ri-file-list-3-line text-gm-50 text-[24px]"></i>
                                <p className="text-slate-500 font-rocGroteskMedium text-[12px]">
                                    No potential stockout event !
                                </p>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default PotentialStockOuts;
